import React from "react";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { MoreHoriz } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

const MoreMenu = (props) => {
  const { activeInvoice, copy, toggleVoidConfirmationModal } = props;

  if (!activeInvoice) return null;
  // console.log("more menu got active invoice");
  // console.dir(activeInvoice);
  const DRAFT = activeInvoice.status === "DRAFT";
  const OPEN = activeInvoice.status === "OPEN";

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, fun) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    if (fun) fun();
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      <div>
        <Button
          ref={anchorRef}
          // aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MoreHoriz />
        </Button>

        <Popper
          style={{ zIndex: 10000 }}
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-end"
          disablePortal={false}
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
          transition
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              // style={{
              //   transformOrigin:
              //     placement === "bottom" ? "center top" : "center bottom",
              // }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    {/* {document.queryCommandSupported("copy") &&
                      !activeInvoice.DRAFT &&
                      activeInvoice.invoiceLink && (
                        <a
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={copy}
                        >
                          Copy Invoice Link
                        </a>
                      )} */}
                    {document.queryCommandSupported("copy") &&
                      !DRAFT &&
                      activeInvoice.invoiceLink && (
                        <MenuItem onClick={(e) => handleClose(e, copy)}>
                          Copy Invoice Link
                        </MenuItem>
                      )}
                    {(OPEN || DRAFT) && (
                      <MenuItem
                        onClick={(e) =>
                          handleClose(e, toggleVoidConfirmationModal)
                        }
                      >
                        Void Invoice
                      </MenuItem>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
};
export default MoreMenu;
